<template>
    <div>
        <a-carousel :autoplay="true">
            <img v-for="(item,i) in src" :key="i" :src="item.url" alt="" class="medium" style="width: 100%">
        </a-carousel>
    </div>
</template>

<script>
import {get} from "@/utils";

export default {
    name: 'carousel',
    data() {
        return {
            src: [],
        }
    },
    mounted() {
        get('banner/getBannerList', {}).then(res => {
            this.src = res.data.image || [];
        }).catch(() => {
        })
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>
